import * as React from "react"
import * as _ from "lodash"
import {connect} from "react-redux"
import { ChangeEvent } from "react" 
import { IPatientSurgeryAndProcedure } from "@curefit/ehr-common";
import TextInput from "../TextInput";
import TypeAhead, { TypeAheadElement } from "../TypeAhead";
import {IAppState} from "../../models/IAppState";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import * as $ from "jquery";
import TextAreaAutoResize from "../TextAreaAutoResize";


export interface ISurgeryItemEditorProps {
    item: IPatientSurgeryAndProcedure;
    onDataChange: (update: any) => any;
    surgeryTypeAhead: IStaticDataValue[];
}

export interface ISurgeryItemEditorState {
    validate: boolean;
}

class SurgeryItemEditor extends React.Component<ISurgeryItemEditorProps, ISurgeryItemEditorState> {
    private surgeryDOM: any;

    constructor(props: ISurgeryItemEditorProps) {
        super(props);
        this.state = {
            validate: false
        }
    }

    componentDidMount() {
        let myInstance = this;
        $(this.surgeryDOM).find("input").on("blur", function() {
            setTimeout(function() {
                if ( $(myInstance.surgeryDOM).find("input:focus").length === 0 ) {
                    myInstance.setState({validate: true})
                }
            }, 100)
        })
    }

    // onSurgeryNameChange = (event: ChangeEvent<HTMLInputElement>, meta: any) => {
    //     let updatedItem = Object.assign({}, this.props.item, {surgeryName: event.target.value});
    //     this.props.onDataChange(updatedItem)
    // };

    onSurgeryNameChange = (input: string) => {
        let updatedItem = { ...this.props.item, displayValue: input, internalValue: input };
        this.props.onDataChange(updatedItem);

        if (this.props.surgeryTypeAhead && this.props.surgeryTypeAhead.length) {
            let typeAheadList = this.props.surgeryTypeAhead;
            let surgeryTypeAhead: TypeAheadElement[] = [];
            _.map(typeAheadList, (surgery) => {
                if (surgery.displayValue.toLowerCase().indexOf(input) !== -1) {
                    let typeAheadElement: TypeAheadElement = {
                        value: surgery.internalValue,
                        label: surgery.displayValue
                    }
                    surgeryTypeAhead.push(typeAheadElement);
                }
            })
            return Promise.resolve({options: surgeryTypeAhead, completed: true})
        }
    };

    onSurgeryNameSelect = (elem: TypeAheadElement) => {
        let updatedItem = { ...this.props.item, internalValue: elem.value, displayValue: elem.label };
        this.props.onDataChange(updatedItem);
    }

    onSurgeryYearChange = (event: ChangeEvent<HTMLInputElement>, meta: any) => {
        let updatedItem = Object.assign({}, this.props.item, {year: parseInt(event.target.value)})
        this.props.onDataChange(updatedItem)
    };

    onSurgeryCommentChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        let updatedItem = Object.assign({}, this.props.item, { comment: event.target.value })
        this.props.onDataChange(updatedItem)
    }

    render() {
        let surgeryNameValidationStatus = this.state.validate && _.isEmpty(this.props.item.displayValue) ? "error" : "";
        return (
            <div  className="surgery-item-editor" style={{ width: "100%" }} ref={(surgeryDOM) => this.surgeryDOM = surgeryDOM}>
                <div className={`surgery-editor-name ${surgeryNameValidationStatus}`}>
                    <TypeAhead widgetName={"SurgeryItemEditor"} name="surgery-name" value={this.props.item.displayValue || ""} placeholder={"Surgery Name"} onTypeAheadChange={this.onSurgeryNameChange} onTypeAheadSelect={this.onSurgeryNameSelect}/>
                </div>
                <div className="surgery-editor-year">
                    <TextInput name="surgery-year" value={this.props.item.year || ""} placeholder={"Year"} onChange={this.onSurgeryYearChange}/>
                </div>
                <div className="surgery-editor-comments">
                    <TextAreaAutoResize
                        name={"surgery-editor-comments"}
                        className={"textarea-input form-control"}
                        value={this.props.item.comment || ""}
                        placeholder={"Add Comments"}
                        onChange={this.onSurgeryCommentChange}
                        rows={2}
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: IAppState) => {
    let {allStaticDataNew} = state;
    return {surgeryTypeAhead: allStaticDataNew.surgery.values};
}

export default connect(mapStateToProps, {})(SurgeryItemEditor);
